/**
 * Futures (COIN-M) WebSocket API
 *
 * Access market data, manage accounts, and trade COIN-M perpetual and delivery futures.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { WebsocketAPIBase, WebsocketApiResponse, WebsocketSendMsgOptions } from '@binance/common';
import type { AccountInformationResponse, FuturesAccountBalanceResponse } from '../types';

/**
 * AccountApi - interface
 *
 * @interface AccountApi
 */
export interface AccountApiInterface {
    /**
     * Get current account information. User in single-asset/ multi-assets mode
     * will see different value, see comments in response section for detail.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Account Information (USER_DATA)
     * @param {AccountInformationRequest} requestParameters Request parameters.
     *
     * @returns {Promise<AccountInformationResponse>}
     * @memberof AccountApiInterface
     */
    accountInformation(
        requestParameters?: AccountInformationRequest
    ): Promise<WebsocketApiResponse<AccountInformationResponse>>;

    /**
     * Futures Account Balance
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Futures Account Balance (USER_DATA)
     * @param {FuturesAccountBalanceRequest} requestParameters Request parameters.
     *
     * @returns {Promise<FuturesAccountBalanceResponse>}
     * @memberof AccountApiInterface
     */
    futuresAccountBalance(
        requestParameters?: FuturesAccountBalanceRequest
    ): Promise<WebsocketApiResponse<FuturesAccountBalanceResponse>>;
}

/**
 * Request parameters for accountInformation operation in AccountApi.
 * @interface AccountInformationRequest
 */
export interface AccountInformationRequest {
    /**
     *
     * @type {string}
     * @memberof AccountApiAccountInformation
     */
    readonly id?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AccountApiAccountInformation
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for futuresAccountBalance operation in AccountApi.
 * @interface FuturesAccountBalanceRequest
 */
export interface FuturesAccountBalanceRequest {
    /**
     *
     * @type {string}
     * @memberof AccountApiFuturesAccountBalance
     */
    readonly id?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AccountApiFuturesAccountBalance
     */
    readonly recvWindow?: number | bigint;
}

/**
 * AccountApi - object-oriented interface
 * @class AccountApi
 * @extends {WebsocketAPIBase}
 */
export class AccountApi implements AccountApiInterface {
    private readonly websocketBase: WebsocketAPIBase;

    constructor(websocketBase: WebsocketAPIBase) {
        this.websocketBase = websocketBase;
    }

    /**
     * Get current account information. User in single-asset/ multi-assets mode
     * will see different value, see comments in response section for detail.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Account Information (USER_DATA)
     * @param {AccountInformationRequest} requestParameters Request parameters.
     * @returns {Promise<AccountInformationResponse>}
     * @memberof AccountApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-coin-m-futures/api/ws-api/account#account-information Binance API Documentation}
     */
    public accountInformation(
        requestParameters: AccountInformationRequest = {}
    ): Promise<WebsocketApiResponse<AccountInformationResponse>> {
        return this.websocketBase.sendMessage<AccountInformationResponse>(
            '/account.status'.slice(1),
            requestParameters as unknown as WebsocketSendMsgOptions,
            { isSigned: true, withApiKey: false }
        );
    }

    /**
     * Futures Account Balance
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Futures Account Balance (USER_DATA)
     * @param {FuturesAccountBalanceRequest} requestParameters Request parameters.
     * @returns {Promise<FuturesAccountBalanceResponse>}
     * @memberof AccountApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-coin-m-futures/api/ws-api/account#futures-account-balance Binance API Documentation}
     */
    public futuresAccountBalance(
        requestParameters: FuturesAccountBalanceRequest = {}
    ): Promise<WebsocketApiResponse<FuturesAccountBalanceResponse>> {
        return this.websocketBase.sendMessage<FuturesAccountBalanceResponse>(
            '/account.balance'.slice(1),
            requestParameters as unknown as WebsocketSendMsgOptions,
            { isSigned: true, withApiKey: false }
        );
    }
}
